import React, { useState, useEffect } from "react";
import axios from "axios";
import Carousel from "react-bootstrap/Carousel";

import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";

export const RecommendedPrompts = (props) => {
  const [promptList, setPromptlist] = useState();
  const [retry, setRetry] = useState(false);

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  function reload() {
    setPromptlist([]);
    setRetry(true);
    axios
      .post(process.env.REACT_APP_API_DOMAIN + "/recommendPrompts", {
        database:
          props.partnerMetadata.partner_name.toUpperCase() + "_AGENT_V2",
      })
      .then((response) => {
        setPromptlist(response.data.response);
        localStorage.setItem(
          "recommendedPrompts_" + props.partnerMetadata.partner_name,
          JSON.stringify(response.data.response)
        );
        setRetry(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (props.partnerMetadata != undefined && retry == false) {
      if (
        localStorage.getItem(
          "recommendedPrompts_" + props.partnerMetadata.partner_name
        ) == undefined
      ) {
        setRetry(true);
        try {
          axios
            .post(process.env.REACT_APP_API_DOMAIN + "/recommendPrompts", {
              database:
                props.partnerMetadata.partner_name.toUpperCase() + "_AGENT_V2",
            })
            .then((response) => {
              setPromptlist(response.data.response);

              localStorage.setItem(
                "recommendedPrompts_" + props.partnerMetadata.partner_name,
                JSON.stringify(response.data.response)
              );
              setRetry(false);
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          console.error("Error processing message:", error);
        } finally {
        }
      } else {
        setPromptlist(
          JSON.parse(
            localStorage.getItem(
              "recommendedPrompts_" + props.partnerMetadata.partner_name
            )
          )
        );
      }
    }
  }, [props.partnerMetadata]);

  function onSetPrompt(id) {
    props.setRecentPrompt(id);
  }

  return (
    <div className="recentPromptsContainer">
      <div>
        <Stack direction="vertical" gap={10}>
          <div className="recentPromptsList">
            <div className="recentPromptsHeader">Suggested Prompts</div>

            {promptList != undefined && retry == false ? (
              <div>
                {promptList.map((prompt, i) => {
                  return (
                    <Button
                      onClick={() => onSetPrompt(prompt)}
                      variant="outline-primary"
                      className="promptButton"
                    >
                      <div className="recentPromptText">{prompt}</div>
                    </Button>
                  );
                })}
                <Button
                  onClick={() => reload()}
                  variant="light"
                  className="promptButton"
                >
                  <div className="recentPromptText">Get More Suggestions</div>
                </Button>
              </div>
            ) : (
              <div className="monitorLoader">
                <p>&nbsp;</p>
                <Spinner animation="border" variant="secondary" />
              </div>
            )}
          </div>
        </Stack>
      </div>
    </div>
  );
};

export default RecommendedPrompts;

// {
//   /* <Carousel>
//   <Carousel.Item>
//     <ExampleCarouselImage text="First slide" />
//     <Carousel.Caption>
//       <h3>First slide label</h3>
//       <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p>
//     </Carousel.Caption>
//   </Carousel.Item>
//   <Carousel.Item>
//     <ExampleCarouselImage text="Second slide" />
//     <Carousel.Caption>
//       <h3>Second slide label</h3>
//       <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
//     </Carousel.Caption>
//   </Carousel.Item>
//   <Carousel.Item>
//     <ExampleCarouselImage text="Third slide" />
//     <Carousel.Caption>
//       <h3>Third slide label</h3>
//       <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p>
//     </Carousel.Caption>
//   </Carousel.Item>
// </Carousel>; */
// }
